<template>
    <div @mouseleave="leave">
        <div class="headerBox" id="changBg" >
					<img  class="headerLogo" src="../img/daoxiIcon.png" mode="aspectFill"  @click="gohome()" /> 
           <el-menu :default-active="navLeftActive" class="el-menu-demo"  mode="horizontal">
                <el-menu-item :index="item.url" v-for="(item,index) in menu" :key="index" @mouseenter.native="enter(index,item)" @mouseleave.native="leave2(item.children)" @click.native="getOpt(index,item)">
									{{item.catname}}
									<ul :class="childrenOne==true?'childrenUl':''" v-show="navIndex==index&&seen">
										<!-- <div class="tip-trangle-top"></div> -->
										<li v-for="(itemson,i) in item.children" :key="i" @click.stop="getOpt(i,itemson)" @mouseenter="i==0?childrenNavOpt():''" @mouseleave="i==0?childrenNavOpt():''">{{itemson.catname}}</li>	
									</ul>
								</el-menu-item>
            </el-menu>
					<div class="languageChange"> 
						<div class="searchBox">
							<!-- <div class="searchTextBox" v-if='searchShow' @click="searchOn()">
								<i class="el-icon-search"></i>
								<span>{{searchText2}}</span>
							</div> -->
							<div :class="searchShow?'searchInput searchInputNo':'searchInput'" ><!--v-else-->
								<el-input
									placeholder="search"
									ref="searchBox"
									v-model="searchText" @blur="getBlur()" @keyup.enter.native="handleSubmit" @focus="searchOn()">
									<i slot="prefix" class="el-input__icon el-icon-search"></i>
								</el-input>
								<ul class="productBox" v-show="!searchShow">
									<li v-for="(item,index) in productTextList" :key="index" @click.stop="goProduct(item)">{{item}}</li>	
								</ul>
							</div>
						</div>
						<div class="line"></div>
						<strong><a href="http://cn.kuanbaorui.com">CH</a></strong>/<strong class="language-pitch-on">EN</strong> 
					</div>
        </div>
    </div>
</template>
<style scoped>
/deep/.languageChange a{color: #999; text-decoration:none;}
.headerBox{width: 100%; height:58px;display: flex; align-items: center;justify-content: center;position: relative;z-index: 9999999;}
#changBg{background: white;}
#changBg ul li,#changBg .languageChange .language-pitch-on{ color: black;}
.el-menu{ border:none;background: none; }
.el-menu li{font-size: 14px; color: white;}
.el-menu li:hover{ background: none !important;}
.headerLogo {width: 71px; height: 42px;position: relative;}
.languageChange {margin-left: 10.625vw;position: relative;display: flex;align-items: center;}
.languageChange strong{margin: 0 5px; color: #999999;}
.languageChange .language-pitch-on {color: white;font-size: 14px;}
.searchBox{min-width: 265px;}
.searchTextBox{display: flex;align-items: center;width: 240px;height: 30px;line-height: 30px;border-radius: 30px;padding: 0 10px;box-sizing: border-box; background: #F5F5F5;}
.searchTextBox .el-icon-search{font-size: 16px;font-weight: bold;margin-top:1px;}
.searchTextBox span{margin-left: 12px; font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;}
.searchInput {position: relative;}
.searchInput .el-input{width: 240px;}
/deep/.searchInput .el-input__prefix {color: #000;font-weight: bold;}
/deep/.searchInput .el-input__icon{font-size: 16px;line-height: 30px;color: #000;font-weight: bold;}
/deep/.searchInput .el-input__inner {font-size: 12px;-webkit-appearance: none;background-color: #FFF;background-image: none;border-radius: 30px;border: 2px solid #009144;-webkit-box-sizing: border-box;box-sizing: border-box;color: #999;display: inline-block;height: 30px;line-height: 30px;outline: 0;-webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);transition: border-color .2s cubic-bezier(.645,.045,.355,1);width: 100%;}
{width: 240px;}
/deep/.searchInputNo .el-input__inner {font-size: 12px;-webkit-appearance: none;background-color: #FFF;background-image: none;border-radius: 30px;border: 0;-webkit-box-sizing: border-box;box-sizing: border-box;color: #999;background: #F5F5F5; display: inline-block;height: 30px;line-height: 30px;outline: 0;-webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);transition: border-color .2s cubic-bezier(.645,.045,.355,1);width: 100%;}
.searchInput .productBox{margin-top:5px; position: absolute;background: #FFF;width: 240px;border: 1px solid #F2F2F2;box-shadow: 0px 7px 14px 2px rgba(137, 137, 137, 0.19);border-radius: 6px;padding: 16px 0;box-sizing: border-box;}
.searchInput .productBox li{font-size: 14px;line-height: 30px;padding: 0 12px;box-sizing: border-box;}
.searchInput .productBox li:hover{background: #F4F7F2;font-family: Adobe Heiti Std;font-weight: normal;color: #009143!important;}
.languageChange .line{width: 1px;height: 20px;background: #E6E6E6;margin-right: 24px;}
.is-active{background: none !important;}
#Bblack{background: black;}
.introduction{background-color: #FFF;}/*position: absolute;width: 100%;*/
.introductionBox{width: 932px;margin:0 auto;padding-left: 270px;box-sizing: border-box;}
.ulBottom{height: 346px!important;}
.el-menu-demo{min-width: 386px;margin-left: 6.25vw;}
.el-menu-item{text-align: center;position: relative;padding: 0 1.8vw;box-sizing: border-box;}
.el-menu-item ul{font-size: 14px;text-align: center;line-height: 90px;width:300px;margin: 15px 0;position: absolute;left:-80px;background: #FFF;top:44px;border: 1px solid #EDEDED;box-shadow: 0px 14px 14px 2px rgba(137, 137, 137, 0.31);}
.el-menu-item ul::before{box-sizing: content-box;width: 0px;height: 0px;position: absolute;top: -30px;;right:141px;padding:0;border-bottom:15px solid #FFFFFF;border-top:15px solid transparent;border-left:15px solid transparent;border-right:15px solid transparent;display: block;content:'';z-index: 12;
    }
.el-menu-item ul:after{box-sizing: content-box;width: 0px;height: 0px;position: absolute;top: -32px;;right:140px;padding:0;border-bottom:16px solid #cccccc;border-top:16px solid transparent;border-left:16px solid transparent;border-right:16px solid transparent;display: block;content:'';z-index:10}
/* .tip-trangle-top {position: absolute;top: -10px;left: 24px;width: 0;height: 0;border-left: 15px solid transparent;border-right: 15px solid transparent;border-bottom: 15px solid #fff;} */
.el-menu-item ul li{color: #999999!important;cursor:pointer;}
.el-menu-item ul li:hover{background: #F1CA89!important;color: #FFF!important;cursor:pointer;}
.el-menu-item ul li.titleOpt{color: #000000!important;}
/deep/.el-menu.el-menu--horizontal{border: initial;}
.el-menu--horizontal>.el-menu-item.is-active{border-bottom:initial;color:#009143!important;font-weight: bold;}
.el-menu-item:hover{color:#009143!important;}
.el-menu-item .childrenUl::before{box-sizing: content-box;width: 0px;height: 0px;position: absolute;top: -30px;;right:141px;padding:0;border-bottom:15px solid #F1CA89!important;border-top:15px solid transparent;border-left:15px solid transparent;border-right:15px solid transparent;display: block;content:'';z-index: 12;
    }
</style>

<script>
import * as axios from '../../src/axios/api.js'
  export default {
	  props:['pagefor'],
    data() {
      return {
				searchText2:'请输入搜索的产品名称',
				seen: false,
				navIndex:NaN,
				menu:[],
				childrenOne:false,
				searchShow:true,
				searchText:'',
				productTextList:[
				],
      };
    },
	 	created(){
		 	this.getNavigation();
		},
		computed: {
        navLeftActive: function() {
						const {meta, path} = this.$route
            if(meta.activeMenu){
								return meta.activeMenu+'?id=25'
						}
            return path
				}
		},	
    methods: {
		getNavigation() {
			axios.post('/api/index/config').then(res => {
					if(res.code==1){
						this.menu=res.data.menu
						this.productTextList =res.data.search_keywords
					}
			});
		},
		gohome(){
			 this.$router.push({name:'first'});
		},
		goProduct(item){
			this.searchText=item
			this.$router.push({path: "/search",query: {keywords:item}});
		},
		handleSubmit(){
			var that=this
			that.searchShow=true
			this.$router.push({path: "/search",query: {keywords:that.searchText}});
		},
		getOpt(index,item){
			let path=''
			if(item.url.indexOf('?')!=-1){
				if(item.url.indexOf('id')!=-1){
					path=item.url
				}else{
					path=item.url+'&id='+item.id
				}
				this.$router.push(path)
			}else{
				path=item.url
				this.$router.push({path: path,query: {id:item.id}});
			}
		},
		childrenNavOpt(){
			this.childrenOne=!this.childrenOne
		},
		searchOn(){
			var that=this
			that.searchShow=!this.searchShow
			that.$nextTick(function () { 
				that.$refs.searchBox.focus();
			})
		},
		getBlur(){
			var that=this
			setTimeout(function () {
					that.searchShow=true
			}, 500)
		},
		enter(index,arr){
			if(arr.children && arr.children.length>0){
				this.seen=true;
			}else{
				this.seen=false;
			}
			this.navIndex=index;
			// if(this.activeIndex=='0'){
			// 	this.activeIndex= '10'
			// }		
		},
		leave(){
			this.seen=false;
			// if(this.activeIndex=='10'){
			// 	this.activeIndex='0';
			// }
		},
		leave2(arr){
			if(!arr){
				this.seen=false;
				// if(this.activeIndex=='10'){
				// 	this.activeIndex='0';
				// }
			}
		}
    }
  }
</script>
